export enum PaymentMethod {
    GROUP_TAB = "GROUPTAB",
}
